import { FC } from 'react';
import compose from 'ia-react-core/~/utils/components/_compose';
import StatusTooltip, { StatusTooltipProps } from './StatusTooltip';
import withTooltip from './withTooltip';

export * from './StatusTooltip';

export default compose<FC<StatusTooltipProps>>(
  withTooltip,
)(StatusTooltip);
